import { UTCTimestamp } from 'lightweight-charts';

/**
 * Normalizes a given Unix timestamp (in seconds) to the start of its period 
 * based on the specified timeframe.
 * 
 * @param timeInSeconds The Unix timestamp in seconds (UTC).
 * @param timeframe The chart timeframe string (e.g., '1m', '1h', '1D', '1W', '1M').
 * @returns The normalized Unix timestamp in seconds (UTC).
 */
export function normalizeTime(timeInSeconds: UTCTimestamp, timeframe: string): UTCTimestamp {
  const date = new Date(timeInSeconds * 1000);

  switch (timeframe) {
    case '1m':
      date.setUTCSeconds(0, 0);
      break;
    // case '3m': // Example for other minute intervals if needed
    //   date.setUTCMinutes(Math.floor(date.getUTCMinutes() / 3) * 3, 0, 0);
    //   break;
    case '5m':
      date.setUTCMinutes(Math.floor(date.getUTCMinutes() / 5) * 5, 0, 0);
      break;
    case '15m':
      date.setUTCMinutes(Math.floor(date.getUTCMinutes() / 15) * 15, 0, 0);
      break;
    case '30m':
      date.setUTCMinutes(Math.floor(date.getUTCMinutes() / 30) * 30, 0, 0);
      break;
    case '1h':
      date.setUTCMinutes(0, 0, 0);
      break;
    // case '2h': // Example for other hour intervals if needed
    //   date.setUTCHours(Math.floor(date.getUTCHours() / 2) * 2, 0, 0, 0);
    //   break;
    case '4h':
      date.setUTCHours(Math.floor(date.getUTCHours() / 4) * 4, 0, 0, 0);
      break;
    // case '6h':
    //   date.setUTCHours(Math.floor(date.getUTCHours() / 6) * 6, 0, 0, 0);
    //   break;
    // case '8h':
    //   date.setUTCHours(Math.floor(date.getUTCHours() / 8) * 8, 0, 0, 0);
    //   break;
    // case '12h':
    //   date.setUTCHours(Math.floor(date.getUTCHours() / 12) * 12, 0, 0, 0);
    //   break;
    case '1D':
    case '1d': // Assuming '1d' might also be used
      date.setUTCHours(0, 0, 0, 0);
      break;
    case '1W':
    case '1w': // Assuming '1w' might also be used
      {
        const currentDay = date.getUTCDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
        // Binance weeks start on Monday UTC.
        const daysToSubtract = (currentDay === 0) ? 6 : (currentDay - 1); // days to go back to reach Monday
        date.setUTCDate(date.getUTCDate() - daysToSubtract);
        date.setUTCHours(0, 0, 0, 0);
      }
      break;
    case '1M':
      date.setUTCDate(1);
      date.setUTCHours(0, 0, 0, 0);
      break;
    default:
      // For unhandled timeframes, log a warning and return the original time.
      // This might occur if the timeframe string is unexpected.
      console.warn(`normalizeTime: Unhandled timeframe '${timeframe}'. Returning original time.`);
      return timeInSeconds;
  }
  return Math.floor(date.getTime() / 1000) as UTCTimestamp;
}